module.exports = __webpack_public_path__ + "static/img/4121_phase_function_Paper_PointsHejduk_Prediction.2623e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4121_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MjKN
// module chunks = 0